import useMediaQueries from "../../../../hooks/useMediaQueries";

// ratio of FUll HD screen
const RATIO = 1920 / 1080;
const MOBILE_RATIO = 1080 / 1920;

const useBgMinHeight = (withUnits: boolean = true) => {
  const { mobileCondition } = useMediaQueries();

  const ratio = mobileCondition ? MOBILE_RATIO : RATIO;

  const maxMinHeight = window.innerHeight;

  const minHeight = Math.min(maxMinHeight, window.innerWidth / ratio);

  const getMinHeight = () => {
    return withUnits ? `${minHeight}px` : minHeight + "";
  };

  return {
    minHeight: getMinHeight(),
    getMinHeight,
    ratio,
  };
};

export default useBgMinHeight;
